export default __webpack_public_path__ + "static/media/hidraulic11.73cf7d60.jpg";